import $ from 'jquery';

import application from 'application/application';

const controller = 'LoginController';

application.controller(controller, [
	'$scope',
	'$http',
	'helper',
	'API',
	'authentication',
	'$state',
	'transformDate',
	($scope, $http, helper, API, authentication, $state, transformDate) => {
		$scope.renderDate = new Date();

		$scope.inputType = 'password';

		$scope.checkPartner = url => {
			localStorage.clear();

			$('.busy-overlay').addClass('open');

			$http({
				...helper.http(API.partner, 'GET'),
				params: {
					UrlAcessoCliente: url,
					campos: '*'
				}
			})
				.then(response => {
					if (response.data.itens && response.data.itens.length) {
						$scope.partner = response.data.itens;

						$state.current.data.documentTitle =
							response.data.itens[0].nomeParceiro;

						if (response.data.itens[0].logo) {
							$scope.logoPartner = {
								avatar: `data:image/png;charset=utf-8;base64, ${response.data.itens[0].logo}`
							};

							localStorage.setItem(
								'__authenticationLogo__',
								response.data.itens[0].logo
							);
						}

						localStorage.setItem(
							'__authenticationIdParceiro__',
							response.data.itens[0].idParceiro
						);
					}
				})

				.finally(() => $('.busy-overlay').removeClass('open'));
		};

		let path = location;

		$scope.checkPartner(path.origin);

		$scope.signIn = auth => {
			let logoPartner = localStorage.getItem('__authenticationLogo__');

			Object.keys(localStorage).forEach(
				value =>
					/^__authentication\w+__$/i.test(value) &&
					localStorage.removeItem(value)
			);

			localStorage.setItem('__authenticationLogo__', logoPartner);

			auth['access_type'] = '94be650011cf412ca906fc335f615cdc';

			if ($scope.partner) auth['idParceiro'] = $scope.partner[0].idParceiro;

			auth['grant_type'] = 'password';

			$http({
				...helper.http(API.login, 'POST'),
				data: auth
			}).then(response => {
				transformDate.formatDate(response.data.expires_in);
				$('.busy-overlay').addClass('open');

				authentication.signIn(response.data, () => location.reload()),
					() => $('.busy-overlay').removeClass('open');
			});
		};

		$scope.reload = () => location.reload();

		$scope.forgotPassword = auth => {
			$http({
				...helper.http(API.forgotPassword, 'POST'),
				data: {
					email: auth.username
				}
			});
		};

		$scope.showPassword = () => {
			$scope.inputType = $scope.inputType === 'password' ? 'text' : 'password';
		};
	}
]);

export default controller;
